// extracted by mini-css-extract-plugin
export var borderRadius = "_c3-4";
export var large = "_c3-3";
export var logoContainer = "_c3-0";
export var nameLogo = "_c3-2";
export var small = "_c3-1";